import { Component, Input, Output, EventEmitter } from '@angular/core';
import { InboundFax } from '../../../core/models/inbound-fax.model';
import { SimilarInboundFax } from 'app/core/models/similar-inbound-fax.model';
import { PdfFileType } from '../../../core/enums/pdf-file-type.enum';
import { SimilarInboundFaxState } from 'app/capture-admin/pages/capture-admin-inbound-fax/capture-admin-inbound-fax.component';
import { DatePipe } from '@angular/common';
import { InboundFaxDuplicatePromptComponent } from '../inbound-fax-duplicate-prompt/inbound-fax-duplicate-prompt.component';
import { OfficeComponent } from '../../../shared/components/office/office.component';
import { PdfBasicViewerComponent } from '../../../shared/components/pdf-basic-viewer/pdf-basic-viewer.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { FaxStatusPipe } from '../../../shared/pipes/fax-status.pipe';
import { PatientAttachmentStatusPipe } from 'app/shared/pipes/patient-attachment-status.pipe';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';

@Component({
    selector: 'app-inbound-fax-duplicate-documents-tab',
    templateUrl: './inbound-fax-duplicate-documents-tab.component.html',
    styleUrls: ['./inbound-fax-duplicate-documents-tab.component.scss'],
    imports: [InboundFaxDuplicatePromptComponent,
              OfficeComponent,
              PdfBasicViewerComponent,
              MatProgressSpinner,
              DatePipe,
              FaxStatusPipe,
              PatientAttachmentStatusPipe,
              BlankValueDashPipe]
})
export class InboundFaxDuplicateDocumentsTabComponent {
  pdfFileType: PdfFileType = PdfFileType.inboundFax;

  similarInboundFaxes: SimilarInboundFax[];
  loading = true;
  selectedSimilarInboundFax: SimilarInboundFax;

  @Input() inboundFax: InboundFax;

  @Input()
  set similarInboundFaxState(newState: SimilarInboundFaxState) {
    if (newState.similarInboundFaxes.length > 0) {
      this.loading = false;
      this.similarInboundFaxes = newState.similarInboundFaxes;
      this.selectedSimilarInboundFax = newState.similarInboundFaxes[0];
    } else {
      this.loading = true;
    }
  }

  @Output() duplicateCheckPromptSubmitted =
    new EventEmitter<{ duplicate: boolean, selectedSimilarInboundFax: SimilarInboundFax }>();

  onSelectedSimilarFaxChanged(newSelectedSimilarInboundFax: SimilarInboundFax) {
    this.selectedSimilarInboundFax = newSelectedSimilarInboundFax;
  }

  onDuplicatePromptSubmission(result: { duplicate: boolean }) {
    // Note: The selected fax below doesn't match the selected fax in the UI.
    // This is intentional for now and results in associating the similar fax highest
    // LCS ratio when the form is submitted.
    const updatedResult = {
      ...result,
      selectedSimilarInboundFax: this.similarInboundFaxes[0],
    };

    this.duplicateCheckPromptSubmitted.emit(updatedResult);
  }

  onSimilarInboundFaxPdfUrlChange(url: string) {
    this.selectedSimilarInboundFax.url = url;
  }
}
